import { ImageMessage } from '@lowcodeunit/lcu-file-uploader-common';
import { UserPhoto } from './user-photo.model';

export class UserAlbum{
public ID?: any;
public Photos: Array<UserPhoto>;
public Title: String;

constructor(photos: Array<UserPhoto>, title: string, id?: any){
    this.Photos = photos;
    this.Title = title;
    this.ID = id;
}
}